import {
  getVideo,
  updateShortVideo,
  exportShortVideo,
  mapApiTextOverlayToFe,
  mapApiGifOverlayToFe,
} from "./edit-short-video.service";

export const editShortVideoService = {
  getVideo,
  updateShortVideo,
  exportShortVideo,
};

export { mapApiTextOverlayToFe, mapApiGifOverlayToFe };
